<template>
  <el-dialog v-model="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="Text Edit"
             width="300" @open="onOpen">
    <el-input
        type="textarea"
        autocomplete="off"
        clearable
        :maxlength="20"
        v-model="inputValue"
        placeholder="input"
        show-word-limit/>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="loading" @click="onSubmit">
          Confirm
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
  import {ref} from "vue";
  import {ElMessage} from 'element-plus'

  // 文本值
  const inputValue = ref("");
  /** 提交中状态 */
  const loading = ref(false);

  const props = defineProps({
    /** 修改回显的数据 */
    data: String
  });

  const emit = defineEmits(['submit']);

  /** 弹窗是否打开 */
  const dialogVisible = defineModel({type: Boolean});

  // 提交
  const onSubmit = () => {
    loading.value = true;
    if (inputValue.value === '') {
      ElMessage.error('Please input text');
      loading.value = false;
      return;
    }
    loading.value = false;
    dialogVisible.value = false;
    emit('submit', inputValue.value);
    // 提交后清空文本框
    inputValue.value = "";
  }

  /**
   * Dialog 打开的回调
   */
  const onOpen = () => {
    inputValue.value = props.data;
  }
</script>
<style scoped>

</style>